import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { NOTIFICATION_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type { ReactElement } from 'react'
import type { TestManagementToolInputs } from '@eggplant/types'

interface Props {
  children?: (response: TestManagementToolInputs) => ReactElement
  onSuccess?: (notificationSettings: TestManagementToolInputs) => void
  params: TestManagementToolInputs
}

const CreateTestManagementIntegrationRequest = ({
  children,
  onSuccess,
  params
}: Props) => {
  const url = `${NOTIFICATION_SERVICE}/integrations`

  const { requestParams } = useGetParamsWithSpaceId<TestManagementToolInputs>(params)

  return (
    <AuthenticatedDataRequest
      children={children}
      method='post'
      onSuccess={onSuccess}
      params={requestParams}
      url={url}
    />
  )
}

export default CreateTestManagementIntegrationRequest
